import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContentLoadErrorBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M69 40C69 23.9837 56.0162 11 40 11C23.9837 11 11 23.9838 11 40C11 56.0163 23.9837 69 40 69C56.0163 69 69 56.0163 69 40ZM71 40C71 57.1208 57.1208 71 40 71C22.8792 71 9 57.1208 9 40C8.99999 22.8792 22.8792 9.00001 40 9C57.1208 9 71 22.8792 71 40Z",
			fill: "#E14949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39 42.5L39 25C39 24.4477 39.4477 24 40 24C40.5523 24 41 24.4477 41 25L41 42.5C41 43.0523 40.5523 43.5 40 43.5C39.4477 43.5 39 43.0523 39 42.5Z",
			fill: "#E14949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40 56C41.1046 56 42 55.1046 42 54C42 52.8954 41.1046 52 40 52C38.8954 52 38 52.8954 38 54C38 55.1046 38.8954 56 40 56Z",
			fill: "#E14949"
		})
	]
});
export default SvgContentLoadErrorBig;
